import { userOrder } from '../states/userOrder';
import { configShop } from '../states/configShop';




export const apiGet = async (url, uuidShop = 0) => {
    const { dataUser } = userOrder.getState();
    try {
        const pleiztUuid = window.location.hostname.split(".")[0];
        const response = await fetch(process.env.REACT_APP_API_URL + url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "pleizt-uuid-new": pleiztUuid, // y se reemplaza la informacion
                "pleizt-service": 0,
                "pleizt-shop-uuid": dataUser?.shopData?.value || 0,
                "branch-uuid": dataUser?.shopData?.value || 0,
            },
        });

        if (!response.ok) throw new Error(`GET ${response.status}: ${response.statusText}`);
        const data = await response.json();
        if (data?.properties) {
            configShop.getState().setDataConfig(data.properties);
        }
        return data;
    } catch (error) {
        console.error('Error en apiGet:', error);
        throw error;
    }
};

// Función POST
export const apiPost = async (url, body, uuidShop = 0) => {
    try {
        const pleiztUuid = window.location.hostname.split(".")[0];
        const response = await fetch(process.env.REACT_APP_API_URL + url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "pleizt-uuid-new": pleiztUuid,
                "pleizt-shop-uuid": userOrder?.shopData?.value || uuidShop,
                "pleizt-service": 0,
            },
            body: JSON.stringify(body),
        });

        // if (!response.ok) throw new Error(`POST ${response.status}: ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error en apiPost:', error);
        throw error;
    }
};
// PLZ-078 parte 2: POST con archivo (FormData). Misma URL (.env) y mismo comercio que apiPost.
// Sin Content-Type: el navegador arma el boundary del multipart.
export const apiPostForm = async (url, fields) => {
    const pleiztUuid = window.location.hostname.split(".")[0];
    const formData = new FormData();
    Object.entries(fields).forEach(([key, value]) => formData.append(key, value));
    const response = await fetch(process.env.REACT_APP_API_URL + url, {
        method: 'POST',
        headers: { "pleizt-uuid-new": pleiztUuid },
        body: formData,
    });
    return await response.json();
};

/*
// Función PUT
export const apiPut = async (url, token, body) => {
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });

        if (!response.ok) throw new Error(`PUT ${response.status}: ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error en apiPut:', error);
        throw error;
    }
};

// Función DELETE
export const apiDelete = async (url, token) => {
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) throw new Error(`DELETE ${response.status}: ${response.statusText}`);
        return await response.json();
    } catch (error) {
        console.error('Error en apiDelete:', error);
        throw error;
    }
};
*/